/**
 * @generated SignedSource<<8f340e12f7a16c5284cf52a14f178ec0>>
 * @relayHash b508b2bbe5d15eec70303f949ec6d8e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 940c3e74d8e7beeff72fffdab3942d7a6dc6fd22ab950249248b7a4c735f1f0c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterSettingsEmbeddedWidgetsAppQuery$variables = {
  helpCenterAri: string;
};
export type HelpCenterSettingsEmbeddedWidgetsAppQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: string;
    readonly widgets?: ReadonlyArray<{
      readonly __typename: string;
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"EmbeddedWidgets_AtlassianCsmWidgetConfiguration_EmbeddedWidgets">;
  } | null | undefined;
};
export type HelpCenterSettingsEmbeddedWidgetsAppQuery = {
  response: HelpCenterSettingsEmbeddedWidgetsAppQuery$data;
  variables: HelpCenterSettingsEmbeddedWidgetsAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "EMBED"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": "widgets(type:\"EMBED\")"
              }
            ],
            "type": "CsmAiHub"
          },
          {
            "kind": "FragmentSpread",
            "name": "EmbeddedWidgets_AtlassianCsmWidgetConfiguration_EmbeddedWidgets"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "type": "CsmAiWidgetConfig"
                  }
                ],
                "storageKey": "widgets(type:\"EMBED\")"
              },
              (v4/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "940c3e74d8e7beeff72fffdab3942d7a6dc6fd22ab950249248b7a4c735f1f0c",
    "metadata": {},
    "name": "HelpCenterSettingsEmbeddedWidgetsAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "06ed5920ca5d58608793ee7dca91ac86";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
